<template>
  <div>
    <page-header
      :page="page"
      right-side-class="align-items-end d-flex pb-2 justify-content-end col-4"
    >
      <template #customActions>
        <action-button
          class="mr-2"
          i="fas fa-arrow-circle-left"
          variant="outline-success"
          @click="onGoBack"
        >
          Regresar
        </action-button>
        <action-button
          v-if="canSaveContract && canShowSaveButton"
          i="fas fas fa-save"
          variant="success"
          @click="save"
        >
          Guardar
        </action-button>
        <dropdown
          v-if="visibleDropdownActions.length && !data.isDirectPayment"
          class="download-tariff-sheet-dropdown p-0"
          :items="dropdownActions"
          responsive
          title="Acciones"
        />
      </template>
    </page-header>
    <Provider-Header-Info
      v-model="data"
      :can-edit-ssn="canEditSSNPermission"
      :company-id="parseInt(companyId)"
      @cancel="cancelEditProviderInfo()"
    />
    <div class="c-tabs">
      <b-tabs
        v-model="tabIndex"
        active-nav-item-class="mipe-tab font-weight-bold text-mipe-orange mipe-active-tab"
        active-tab-class=""
        content-class="mt-3"
        nav-class="mipe-tab"
        :no-nav-style="true"
      >
        <b-tab
          active
          title="Información del Proveedor"
          @click="$router.replace({ name: 'provider-edit' })"
        >
          <validation-observer
            ref="providerform"
            v-slot="{ handleSubmit }"
            slim
          >
            <b-form @submit.prevent="handleSubmit(validateSsn)">
              <provider-general-info-form v-model="data" />
              <b-row>
                <div class="mt-3 mb-1 col-12">
                  <address-information-list
                    v-model="data.addresses"
                    :add-enabled="userHasPermissions('provider.address.add')"
                    :delete-enabled="
                      userHasPermissions('provider.address.delete')
                    "
                    :edit-enabled="userHasPermissions('provider.address.edit')"
                    :fiscal-year-id="value.fiscalYearId || Number(fiscalYearId)"
                    :on-deleting="onAddressDeleting"
                    :on-saving="onAddressSaving"
                  />
                </div>
              </b-row>

              <b-row>
                <div class="mt-3 mb-1 col-12">
                  <contact-information-list
                    v-model="data.contacts"
                    :add-enabled="userHasPermissions('provider.contact.add')"
                    :civil-statuses="civilStatuses"
                    :delete-enabled="
                      userHasPermissions('provider.contact.delete')
                    "
                    :edit-enabled="userHasPermissions('provider.contact.edit')"
                    :on-deleting="onContactDeleting"
                    :on-saving="onContactSaving"
                  />
                </div>
              </b-row>

              <b-row>
                <div class="mt-3 mb-1 col-12">
                  <div>
                    <section-title
                      v-if="companyId"
                      class="mt-4 mb-3"
                      has-line
                      title="Documentos de Proveedor"
                    />
                    <div
                      v-if="
                        (!data.documents || data.documents.length === 0) &&
                          !isAdding
                      "
                      class="bg-secondary-3 p-3 mt-3 rounded"
                    >
                      <div>
                        <div class="upload-file-button__container">
                          <div class="panel-row-without-selector p-4">
                            <div class="col-12 text-center">
                              <button
                                class="btn bg-light-white col-12 col-md-4"
                                @click="isAdding = true"
                              >
                                <em class="fas fa-file-plus pr-4 text-green" />
                                <span class="text-button-add-document">
                                  Presione aquí para anejar documento
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="data.documents && data.documents.length > 0">
                      <div
                        v-for="document in data.documents"
                        :key="document.id"
                        class="bg-secondary-3 p-3 mt-3 rounded"
                      >
                        <div class="row px-3">
                          <div class="col-12 col-md-4">
                            <span class="font-weight-normal text-gray font-14">
                              Tipo de Documento:
                            </span>
                            <p class="font-16">
                              {{ document.documentTypeName }}
                            </p>
                          </div>
                          <div class="col-12 col-md-7">
                            <span class="font-weight-normal text-gray font-14">
                              Nombre de Documento:
                            </span>
                            <p class="font-16">{{ document.fileName }}</p>
                          </div>
                          <div class="col-12 col-md-1 text-right">
                            <action-button
                              class="mr-2 mt-2"
                              i="fas fa-file-download"
                              variant="success"
                              @click="() => onDownload(document.documentId)"
                            />
                            <action-button
                              class="mr-2 mt-2"
                              i="fas fa-times-circle"
                              variant="danger"
                              @click="
                                () => onRemoveDocuments(document.documentId)
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="data.documents.length > 0 && !isAdding"
                      class="d-flex justify-content-end mt-3"
                    >
                      <action-button
                        i="fas fa-file-plus"
                        variant="success"
                        @click="isAdding = true"
                      >
                        Añadir
                      </action-button>
                    </div>
                    <div
                      v-if="isAdding"
                      class="bg-secondary-3 p-3 mt-3 rounded"
                    >
                      <validation-observer
                        ref="documentObserver"
                        class="row mx-2 "
                        tag="div"
                      >
                        <div class="col-md-4 col-sm-6">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-drop-down
                              id="ddlDocumentType"
                              v-model="model.documentType"
                              custom-error-msg="Favor seleccionar tipo de documento."
                              :error="errors[0]"
                              fieldkey="id"
                              fieldname="name"
                              label="Tipo de Documento"
                              :options="filteredDocumentTypes"
                            />
                          </validation-provider>
                        </div>
                        <div
                          class="col-md-4 col-sm-6 "
                          :class="model.file && 'd-flex justify-content-center'"
                        >
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-file-input
                              ref="fileUpload"
                              v-model="model.file"
                              accept="pdf"
                              class="mt-4 pt-1"
                              custom-error-msg="Favor seleccionar un documento."
                              display-style="normal"
                              :error="errors[0]"
                              label=""
                              label-position="left"
                              :on-download="() => {}"
                              required
                            />
                          </validation-provider>
                        </div>
                        <div class="col-md-4">
                          <div class="mt-4 text-right">
                            <action-button
                              id="btnCancel"
                              i="fas fa-times-circle"
                              variant="outline-danger btn-cancel danger m-2"
                              @click="closeAdding"
                            >
                              Cancelar
                            </action-button>
                            <action-button
                              id="btnAdd"
                              i="fas fa-file-plus"
                              variant="success pl-4 pr-4"
                              @click="onAdd"
                            >
                              Añadir
                            </action-button>
                          </div>
                        </div>
                      </validation-observer>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-form>
          </validation-observer>
        </b-tab>
        <b-tab
          v-if="showContractTab"
          :active="canActiveContractView"
          title="Contrato"
          @click="$router.replace({ name: 'resultContracts' })"
        >
          <contract-provider
            ref="contratProviderRef"
            :data="data"
            @on-change-model="onChangeModelHandler"
          />
        </b-tab>
        <b-tab
          v-if="isMedicaidDocumentationWorkflowEnabled"
          :active="canActiveMedicaidEligibilityView"
          title="Elegibilidad de Medicaid"
          @click="$router.replace({ name: 'medicaid-eligibility' })"
        >
          <medicaid-eligibility
            v-model="data.nationalIdentifier"
            :medical-identifier.sync="data.medicalIdentifier"
            :provider-id="parseInt(companyId)"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import alert from '@/mixins/alert.mixin';

import PageHeader from 'PageHeader';
import Dropdown from 'dropdown';

import AddressInformationList from '@/views/provider/serviceLocation/components/AddressInformationList';
import ContactInformationList from '@/views/provider/serviceLocation/components/ContactInformationList';
import ProviderGeneralInfoForm from './_components/ProviderGeneralInfo';
import ProviderHeaderInfo from './_components/ProviderHeaderInfo.vue';
import { modulesName } from '@/store';
import { name as providerModulesName } from '@/modules/provider/store';
import MedicaidEligibility from './_components/MedicaidEligibility.vue';

import { mask } from 'ke-the-mask';
import { Wrapper as ContractProvider } from './contract';
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';
import companyTypes from '@/utils/constants/companyTypes.js';
import {
  getProviderDetail as _getProviderDetail,
  createContact as _createContact,
  editContact as _editContact,
  deleteContact as _deleteContact,
  createAddress as _createAddress,
  editAddress as _editAddress,
  deleteAddress as _deleteAddress,
  edit as _editProvider,
  getCivilStatuses,
} from '@/modules/provider/api';

import _generalApi from '@/modules/app/api.js';
import SectionTitle from '@/shared/components/SectionTitle.vue';
import CustomFileInput from 'CustomFileInput';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import {
  getProviderInfoDocumentTypes,
  uploadProviderInfoDocument,
} from '@/modules/shared/provider.api';
import { serialize as objectToFormData } from 'object-to-formdata';
import service from '@/modules/app/api';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';

const PROVIDER_EDIT_ROUTE_NAME = 'provider-edit';
const SIFDE_MAIN_ROUTE_NAME = 'sifde-main';
const MEDICAID_ELIGIBILITY_ROUTE_NAME = 'medicaid-eligibility';

export default {
  name: 'ProviderEdit',
  components: {
    SectionTitle,
    ProviderHeaderInfo,
    ProviderGeneralInfoForm,
    AddressInformationList,
    ContactInformationList,
    ContractProvider,
    PageHeader,
    Dropdown,
    CustomFileInput,
    CustomDropDown,
    ActionButton,
    MedicaidEligibility,
  },
  directives: {
    mask,
  },
  mixins: [storeMixin, unRegisterMixin, alert],
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          rupNumber: '',
          profitType: '',
          ssn: '-',
          companyName: '-',
          companyTypeName: '-',
          website: '-',
          phoneNumber: '-',
          faxNumber: '-',
          companyTypeId: null,
          contacts: [],
          addresses: [],
          locationFiscalYearId: null,
          currentLocationId: null,
          municipality: null,
          civilStatus: null,
          specialty: null,
          licenseNumber: null,
          legalSuffix: null,
          isDirectPayment: null,
          nationalIdentifier: null,
          medicalIdentifier: null,
        };
      },
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-shield-alt',
        title: 'Proveedor',
        routes: ['Inicio', 'Proveedor', 'Editar'],
      },
      companyId: null,
      data: this.value,
      editMode: false,
      fiscalYearId: null,
      modal: {
        show: false,
      },
      contracts: [],
      tabIndex: 0,
      contractModel: null,
      civilStatuses: [],
      isAdding: false,
      model: {},
      documentTypes: [],
      isMedicaidDocumentationWorkflowEnabled: false,
    };
  },
  computed: {
    filteredDocumentTypes() {
      const addedDocs = this.data.documents.flatMap((d) => d.documentTypeId);
      return this.data.documents.length > 0
        ? this.documentTypes.filter((item) => !addedDocs.includes(item.id))
        : this.documentTypes;
    },
    showContractTab() {
      const hasPermission = this.userHasPermissions('provider.contract.view');
      return (
        this.data.companyTypeId !== companyTypes.DirectPaymentInstitutions &&
        hasPermission
      );
    },
    ...mapGetters(modulesName.commonModuleName, ['getValidationMessage']),
    currentFiscalYearId() {
      return this.fiscalYearId;
    },
    canSaveContract() {
      return (
        ((this.contractModel != null || this.tabIndex == 0) &&
          !this.contractModel?.isSignedFlag === true) ||
        this.userHasPermissions('provider.contract.canamendpreviousyear')
      );
    },
    canSignContract() {
      return (
        this.contractModel?.id !== undefined &&
        this.contractModel?.isSignedFlag === false
      );
    },
    canDownloadTariffSheet() {
      return (
        !isNaN(this.contractModel?.id) && this.contractModel?.id != undefined
      );
    },
    canActiveContractView() {
      return ![PROVIDER_EDIT_ROUTE_NAME, SIFDE_MAIN_ROUTE_NAME].includes(
        this.$route.name
      );
    },
    canActiveMedicaidEligibilityView() {
      return this.$route.name === MEDICAID_ELIGIBILITY_ROUTE_NAME;
    },
    canShowSaveButton() {
      return (
        this.tabIndex == 0 ||
        (this.tabIndex == 1 &&
          this.contractModel != null &&
          !this.contractModel?.isSignedFlag)
      );
    },
    visibleDropdownActions() {
      return this.dropdownActions.filter((x) => x.visible);
    },
    dropdownActions() {
      return [
        {
          name: 'formatoPDF',
          label: 'Descargar Hoja de Tarifa PDF',
          icon: 'fas fa-download text-green pr-1',
          visible: this.canDownloadTariffSheet,
          click: () => this.downloadTariffSheettHandler(5),
        },
        {
          name: 'formatoEXCEL',
          label: 'Descargar Hoja de Tarifa EXCEL',
          icon: 'fas fa-download text-green pr-1',
          visible: this.canDownloadTariffSheet,
          click: () => this.downloadTariffSheettHandler(9),
        },
        {
          name: 'print',
          label: 'Imprimir',
          icon: 'fas fa-print text-green pr-1',
          visible:
            (!!this.contractModel?.id && !this.contractModel?.isSignedFlag) ||
            this.userHasPermissions('provider.contract.document.replace'),
          click: () => this.printHandler(),
        },
        {
          name: 'signContract',
          label: 'Firmar Contrato',
          icon: 'fas fa-pen-alt text-green pr-1',
          visible: this.canSignContract,
          click: () => this.signContractHandler(),
        },
      ];
    },
    canEditSSNPermission() {
      return this.userHasPermissions('provider.ssn.edit');
    },
  },
  watch: {
    tabIndex(value) {
      if (value === 0) {
        this.contractModel = null;
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: ['Proveedor', 'Proveedores', 'Editar'],
        };
      } else if (value === 1 && this.showContractTab) {
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: ['Proveedor', 'Proveedores', 'Añadir Proveedor', 'Contrato'],
        };
      } else if (
        (value === 2 && this.showContractTab) ||
        (value === 1 && !this.showContractTab)
      ) {
        this.contractModel = null;
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: [
            'Proveedor',
            'Proveedores',
            'Añadir Proveedor',
            'Elegibilidad de Medicaid',
          ],
        };
      }
    },
  },
  async created() {
    this.companyId = this.$route.params.companyId;
    this.editMode = this.$route.params.editMode;
    this.fiscalYearId = this.$route.params.fiscalYearId;

    await this.loadProviderInformation();
    this.setCompanySSN(this.data.ssn);
  },
  async mounted() {
    await this.getParams();
    const { data } = await getCivilStatuses();
    this.civilStatuses = [...data];
    this.documentTypes = (await getProviderInfoDocumentTypes()).data;
  },
  methods: {
    ...mapActions(providerModulesName, ['setCompanySSN']),
    async getParams() {
      const { data } = await _getSysparameterByNames({
        parameterNames: ['MedicaidDocumentationWorkflowEnabled'],
      });

      this.isMedicaidDocumentationWorkflowEnabled =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
    async onDownload(documentId) {
      if (documentId != undefined) {
        service.downloadDocumentByAttachmentId(documentId).catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
      }
    },
    async onRemoveDocuments(documentId) {
      try {
        const confirmation = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro(a) que desea eliminar el documento seleccionado?',
          'Si',
          'No'
        );

        if (!confirmation) return;

        await service.deleteDocumentByAttachmentId(documentId);
        await this.loadProviderInformation();
        this.ShowToast(
          'Proceso Exitoso',
          'Documento eliminado exitosamente',
          'success'
        );
      } catch (error) {
        this.ShowToast(
          'Error',
          'No ha sido posible eliminar el documento seleccionado.',
          'error'
        );
      }
    },
    async onAdd() {
      const isValid = await this.$refs.documentObserver.validate();
      if (!isValid) return;

      const documents = [
        {
          companyId: this.companyId,
          documentTypeId: this.model.documentType.id,
          file: this.model.file,
        },
      ];

      const { data } = await uploadProviderInfoDocument(
        objectToFormData(
          { documents },
          { indices: true, nullsAsUndefineds: true }
        )
      ).catch((error) => {
        this.ShowToast('', error.response.data.message, 'error');
      });

      if (data) {
        this.closeAdding();
        await this.loadProviderInformation();
        this.ShowToast(
          'Proceso Exitoso',
          'El documento de enmienda se ha añadido exitosamente.',
          'success'
        );
      }
    },
    closeAdding() {
      this.model.file = this.model.documentType = null;
      this.isAdding = false;
    },
    async loadProviderInformation() {
      try {
        const response = await _getProviderDetail(this.companyId);
        this.data = response.data;
      } catch {
        this.ShowToast('Error', 'Ocurrió un error cargando los datos', 'error');
      }
    },
    async save() {
      const isValid = await this.$refs['providerform'].validate();

      if (this.tabIndex == 1) {
        this.$refs.contratProviderRef.$children[0].save();
      } else if (isValid) {
        await _editProvider({
          Id: this.data.id,
          RupNumber: parseInt(this.data.rupNumber),
          ProfitType: parseInt(this.data.profitType),
          Specialty: this.data.specialty,
          LicenseNumber: this.data.licenseNumber,
          Name: this.data.companyName,
          Website: this.data.website,
          PhoneNumber: this.data.phoneNumber,
          FaxNumber: this.data.faxNumber,
          LocationFiscalYearId: this.data.locationFiscalYearId,
          legalSuffix: this.data.legalSuffix.name,
        })
          .then(() => {
            this.ShowToast(
              'Proceso exitoso',
              'Los cambios fueron guardados exitosamente',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast('Error', error.response.data.message, 'error');
          });
      }
    },
    goToProviderSearch() {
      this.$router.push({ name: 'provider' });
    },
    async onAddressSaving(savedAddress) {
      let promise = null;

      //Set the default locationId, the primary address has it (There is always at least a contact)
      savedAddress.locationId =
        this.data.addresses[0]?.locationId ?? this.data.currentLocationId;
      savedAddress.locationFiscalYearId =
        this.data.addresses[0]?.locationFiscalYearId ??
        this.data.locationFiscalYearId;

      savedAddress.gpsLatitude =
        savedAddress.gpsLatitude != null
          ? parseFloat(savedAddress.gpsLatitude)
          : null;
      savedAddress.gpsLongitude =
        savedAddress.gpsLongitude != null
          ? parseFloat(savedAddress.gpsLongitude)
          : null;

      if (savedAddress.addressId == null)
        promise = _createAddress(savedAddress);
      else promise = _editAddress(savedAddress);

      let result = false;

      await promise
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso',
            'Dirección guardada exitosamente.',
            'success'
          );

          savedAddress.addressId = response.data.addressId;

          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onAddressDeleting(contactId) {
      let promise = null;

      promise = _deleteAddress(contactId);

      let result = false;

      await promise
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Dirección eliminada exitosamente.',
            'success'
          );
          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onContactSaving(savedContact) {
      let promise = null;

      //Set the default locationId, the primary contact has it (There is always at least a contact)
      savedContact.locationId = this.data.contacts[0].locationId;
      savedContact.locationFiscalYearId = this.data.contacts[0].locationFiscalYearId;

      if (savedContact.id == null) promise = _createContact(savedContact);
      else promise = _editContact(savedContact);

      let result = false;

      await promise
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso',
            'Contacto guardado exitosamente.',
            'success'
          );

          savedContact.id = response.data.id;

          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      if (result) await this.loadProviderInformation();
      return result;
    },
    async onContactDeleting(contactId) {
      let promise = null;

      promise = _deleteContact(contactId);

      let result = false;

      await promise
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Contacto eliminado exitosamente.',
            'success'
          );
          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    signContractHandler() {
      this.$refs.contratProviderRef.$children[0].signContract();
    },
    async printHandler() {
      try {
        await _generalApi.getContractProviderReport(this.contractModel.id);
      } catch (err) {
        let message =
          err?.response?.data?.message ?? 'Error al descaragr el documento';
        this.ShowToast('', message, 'error');
      }
    },
    async downloadTariffSheettHandler(format) {
      const payload = {
        contractId: this.contractModel.id,
        format,
      };
      await _generalApi.getContractTariffSheetReport(payload);
    },
    onChangeModelHandler(value) {
      this.contractModel = value;
    },
    onGoBack() {
      this.contractModel = null;
      this.$router.go(-1);
    },
    cancelEditProviderInfo() {
      this.model.providerInfo.ssn = this.model.providerInfo.ssnFormated;
      this.isOpenEditProviderInfo = false;
    },
  },
};
</script>

<style lang="sass">
.mipe-tab
  border-bottom: 1px solid #E2E2E2
  display: flex

  .nav-item
    flex: 1 1 0
    text-align: center

    .nav-link
      width: 100%
      display: inline-block
      text-align: center
      padding-left: 0 !important
      padding-right: 0 !important
      font: 16px Lato
      letter-spacing: 0
      padding-bottom: 5px

.mipe-active-tab
  border: 0 !important
  border-bottom: 3px solid var(--mipe-orange) !important
  &::after
    display: none
</style>

<style scoped lang="scss">
.c-tabs {
  ::v-deep .nav-link.active {
    color: #2db782;
    padding-bottom: 5px;
    border-bottom: 3px #2db782 solid !important;
  }
}
.download-tariff-sheet-dropdown {
  margin-left: 8px;
}

.download-tariff-sheet-dropdown {
  ::v-deep .btn {
    padding: 3px 15px;
  }
}

.download-tariff-sheet-dropdown.success {
  ::v-deep .btn {
    background-color: #2db782;
    color: white;
    font-weight: 500;
  }
}
</style>
